import { Component, Input } from "@angular/core";
import { ISim, SimType } from "@app/interfaces/ISim";
import { ISimStatus } from "@app/main/modules/foundation/_models/ISimStatus";
import { SimService } from "@app/main/modules/foundation/_services/sim.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Observable, of } from "rxjs";
import { finalize, mergeMap, tap } from "rxjs/operators";

@UntilDestroy()
@Component({
    selector: 'sim-status',
    template: require('./sim-status.component.html')
})
export class SimStatusComponent {
    @Input() simId: number;


    //--
    sim: ISim;
    simStatusInfo: ISimStatus;

    loading: boolean;

    constructor(
        private readonly simService: SimService) { }

    ngOnInit(): void {
        this.loadData();
    }

    //--

    private loadData(): void {
        this.loading = true;

        this.simService.getSim(this.simId).pipe(
            untilDestroyed(this),
            mergeMap(sim => {
                this.sim = sim;

                if (this.sim.Type == SimType.Tele2 || this.sim.Type == SimType.Aeris || this.sim.Type == SimType.WirelessLogic) {
                    return this.getSimStatus();
                }

                return of(true);
            }),
            finalize(() => this.loading = false))
            .subscribe();
    }

    private getSimStatus(): Observable<ISimStatus> {
        return this.simService.getSimStatusByIccid(this.sim.Iccid, this.sim.Type).pipe(tap(status => {
            this.simStatusInfo = status;
        }));
    }

}
